<div class="dialog-overlay" (click)="!isProcessing() || processingComplete() ? cancel() : null">
  <div class="dialog dialog--wide" (click)="$event.stopPropagation()">
    <div class="dialog__header">
      <div class="dialog__title">Bulk Assign Courses</div>
    </div>
    
    <div class="dialog__content" *ngIf="!isProcessing()">
      <div class="error" *ngIf="selectionError()">
        {{ selectionError() }}
        <button type="button" class="error__close" (click)="selectionError.set('')">×</button>
      </div>
      
      <div class="bulk-assign-grid">
        <!-- Left Column: Members -->
        <div class="selection-column">
          <div class="column-header">
            <h3>Select Members</h3>
            <button type="button" class="btn btn--ghost btn--sm" (click)="selectAllMembers()">
              Select All
            </button>
          </div>
          <div class="checkbox-list">
            <label *ngFor="let member of members" class="checkbox-item">
              <input type="checkbox"
                     [checked]="selectedMembers().has(member.id)"
                     (change)="toggleMember(member.id)">
              <span>{{ member.name }}</span>
            </label>
            <div class="muted" *ngIf="members.length === 0">No members available</div>
          </div>
          <div class="selection-count">{{ selectedMembers().size }} selected</div>
        </div>
        
        <!-- Right Column: Courses -->
        <div class="selection-column">
          <div class="column-header">
            <h3>Select Courses</h3>
            <button type="button" class="btn btn--ghost btn--sm" (click)="selectAllCourses()">
              Select All
            </button>
          </div>
          <div class="checkbox-list">
            <label *ngFor="let course of courses" class="checkbox-item">
              <input type="checkbox"
                     [checked]="selectedCourses().has(course.COURSE_ID)"
                     (change)="toggleCourse(course.COURSE_ID)">
              <span>{{ course.COURSE_NAME }}</span>
            </label>
            
            <!-- Loading state -->
            <div class="loading-state" *ngIf="coursesLoading">
              <span class="spinner"></span>
              <span class="muted">Loading courses...</span>
            </div>
            
            <!-- Empty state (only show when not loading) -->
            <div class="muted" *ngIf="!coursesLoading && courses.length === 0">
              No courses available
            </div>
          </div>
          <div class="selection-count">{{ selectedCourses().size }} selected</div>
        </div>
      </div>
    </div>
    
    <!-- Progress Phase -->
    <div class="dialog__content dialog__content--progress" *ngIf="isProcessing()">
      <!-- Summary Stats (show at top when processing is complete) -->
      <div class="progress-summary" *ngIf="processingComplete()">
        <div class="summary-title">Summary</div>
        <div class="summary-stats">
          <span class="stat stat--success">
            <span class="success-icon">✓</span> {{ countByStatus('success') }} Successful
          </span>
          <span class="stat stat--warning">
            <span class="warning-icon">⚠</span> {{ countByStatus('warning') }} Already Assigned
          </span>
          <span class="stat stat--error">
            <span class="error-icon">✗</span> {{ countByStatus('error') }} Failed
          </span>
        </div>
      </div>
      
      <div class="progress-list">
        <div *ngFor="let item of progressItems()" class="progress-user">
          <div class="progress-user-header">
            <strong>{{ item.memberName }}</strong>
          </div>
          <div class="progress-courses">
            <div *ngFor="let c of item.courses" class="progress-course">
              <span class="progress-icon">
                <span *ngIf="c.status === 'pending'">⏳</span>
                <span *ngIf="c.status === 'processing'" class="spinner"></span>
                <span *ngIf="c.status === 'success'" class="success-icon">✓</span>
                <span *ngIf="c.status === 'warning'" class="warning-icon">⚠</span>
                <span *ngIf="c.status === 'error'" class="error-icon">✗</span>
              </span>
              <span class="progress-course-name">{{ c.courseName }}</span>
              <span *ngIf="c.message" class="progress-message" 
                    [class.success]="c.status === 'success'"
                    [class.warning]="c.status === 'warning'"
                    [class.error]="c.status === 'error'">
                {{ c.message }}
                <span class="status-code" *ngIf="c.statusCode">({{ c.statusCode }})</span>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="dialog__footer">
      <button type="button" 
              class="btn btn--ghost" 
              (click)="cancel()"
              [disabled]="isProcessing() && !processingComplete()">
        {{ isProcessing() ? 'Close' : 'Cancel' }}
      </button>
      <button type="button"
              class="btn btn--success"
              (click)="validateAndProceed()"
              [disabled]="isProcessing()"
              *ngIf="!isProcessing()">
        Assign
      </button>
    </div>
  </div>
</div>
